// Custom Size – unterstützt Varianten-Schaltflächen und Dropdowns
(function () {
  'use strict';

  const wrapper = document.querySelector('.custom-size-wrapper');
  if (!wrapper) return;

  const field1 = wrapper.querySelector('.custom-field-1');
  const field2 = wrapper.querySelector('.custom-field-2');
  const error1 = wrapper.querySelector('.error-1');
  const error2 = wrapper.querySelector('.error-2');

  const form = document.querySelector(
    'product-form-component form[action*="/cart/add"]'
  );

  const variantPicker = document.querySelector('variant-picker');

  if (!field1 || !field2 || !form || !variantPicker) {
    console.error('Custom Size: Erforderliche Elemente nicht gefunden.');
    return;
  }

  const refVariation = wrapper.dataset.refVariation?.trim();
  const field1Label = field1.dataset.label;
  const field2Label = field2.dataset.label;

  let minField1 = parseInt(field1.min, 10);
  let maxField1 = parseInt(field1.max, 10);
  let minField2 = parseInt(field2.min, 10);
  let maxField2 = parseInt(field2.max, 10);

  /*
   * Passende Variantenoption finden.
   * Bei Schaltflächen steht der Name in <legend>.
   * Bei Dropdowns steht der Name in <label>.
   */
  const refOptionContainer = Array.from(
    variantPicker.querySelectorAll('.variant-option')
  ).find((container) => {
    const heading = container.querySelector('legend, label');

    return (
      heading &&
      heading.textContent.trim().toLowerCase() ===
        refVariation.toLowerCase()
    );
  });

  if (!refOptionContainer) {
    console.error(
      `Custom Size: Variantenoption „${refVariation}“ wurde nicht gefunden.`
    );
    return;
  }

  const radioInputs = Array.from(
    refOptionContainer.querySelectorAll('input[type="radio"]')
  );

  const sizeSelect = refOptionContainer.querySelector(
    'select[name^="options["]'
  );

  const sizeOptions = [];

  let analyzedMinField1 = Infinity;
  let analyzedMaxField1 = 0;
  let analyzedMinField2 = Infinity;
  let analyzedMaxField2 = 0;

  function parseSize(value) {
    const match = String(value).match(
      /(\d+)\s*(?:mm)?\s*[-–—xX×/|]|(?:\s+bis\s+)|(?:\s+to\s+)(\d+)/i
    );

    if (match && match[1] && match[2]) {
      return {
        val1: parseInt(match[1], 10),
        val2: parseInt(match[2], 10)
      };
    }

    /*
     * Sicherere zweite Prüfung für typische Werte wie:
     * 800 x 3000 mm
     */
    const fallbackMatch = String(value).match(
      /(\d+)\s*(?:mm)?\s*(?:x|X|×|-|–|—|\/|\||bis|to)\s*(\d+)\s*(?:mm)?/i
    );

    if (!fallbackMatch) return null;

    return {
      val1: parseInt(fallbackMatch[1], 10),
      val2: parseInt(fallbackMatch[2], 10)
    };
  }

  function registerSizeOption(element, type) {
    const parsed = parseSize(element.value);
    if (!parsed) return;

    analyzedMinField1 = Math.min(analyzedMinField1, parsed.val1);
    analyzedMaxField1 = Math.max(analyzedMaxField1, parsed.val1);
    analyzedMinField2 = Math.min(analyzedMinField2, parsed.val2);
    analyzedMaxField2 = Math.max(analyzedMaxField2, parsed.val2);

    sizeOptions.push({
      element,
      type,
      val1: parsed.val1,
      val2: parsed.val2
    });
  }

  /*
   * Variante 1: Schaltflächen
   */
  radioInputs.forEach((radio) => {
    registerSizeOption(radio, 'radio');
  });

  /*
   * Variante 2: Dropdown
   */
  if (sizeSelect) {
    Array.from(sizeSelect.options).forEach((option) => {
      registerSizeOption(option, 'select');
    });
  }

  if (sizeOptions.length === 0) {
    console.error(
      'Custom Size: Es konnten keine auswertbaren Größenvarianten gefunden werden.'
    );
    return;
  }

  if (isNaN(minField1)) minField1 = analyzedMinField1;
  if (isNaN(maxField1)) maxField1 = analyzedMaxField1;
  if (isNaN(minField2)) minField2 = analyzedMinField2;
  if (isNaN(maxField2)) maxField2 = analyzedMaxField2;

  field1.setAttribute('min', minField1);
  field1.setAttribute('max', maxField1);
  field2.setAttribute('min', minField2);
  field2.setAttribute('max', maxField2);

  function isOptionSelected(option) {
    if (option.type === 'radio') {
      return option.element.checked;
    }

    if (option.type === 'select' && sizeSelect) {
      return sizeSelect.value === option.element.value;
    }

    return false;
  }

  const selectedOption = sizeOptions.find(isOptionSelected);

  if (selectedOption) {
    field1.value = selectedOption.val1;
    field2.value = selectedOption.val2;
  } else {
    field1.value = minField1;
    field2.value = minField2;
  }

  let timer;
  let prop1Input;
  let prop2Input;

  function ensurePropertiesExist() {
    const prop1Name = `properties[Individuelle ${field1Label}]`;
    const prop2Name = `properties[Individuelle ${field2Label}]`;

    prop1Input = form.querySelector(
      `input[name="${prop1Name}"]`
    );

    if (!prop1Input) {
      prop1Input = document.createElement('input');
      prop1Input.type = 'hidden';
      prop1Input.name = prop1Name;
      form.appendChild(prop1Input);
    }

    prop2Input = form.querySelector(
      `input[name="${prop2Name}"]`
    );

    if (!prop2Input) {
      prop2Input = document.createElement('input');
      prop2Input.type = 'hidden';
      prop2Input.name = prop2Name;
      form.appendChild(prop2Input);
    }
  }

  function updateProperties() {
    ensurePropertiesExist();

    prop1Input.value = `${field1.value} mm`;
    prop2Input.value = `${field2.value} mm`;

    console.log(
      'Custom Size: Eigenschaften aktualisiert:',
      prop1Input.value,
      prop2Input.value
    );
  }

  function validateInputs() {
    let isValid = true;

    const value1 = parseInt(field1.value, 10);
    const value2 = parseInt(field2.value, 10);

    if (
      isNaN(value1) ||
      value1 < minField1 ||
      value1 > maxField1
    ) {
      error1.textContent =
        `Bitte geben Sie einen Wert zwischen ` +
        `${minField1} und ${maxField1} ein.`;

      error1.style.display = 'block';
      isValid = false;
    } else {
      error1.style.display = 'none';
    }

    if (
      isNaN(value2) ||
      value2 < minField2 ||
      value2 > maxField2
    ) {
      error2.textContent =
        `Bitte geben Sie einen Wert zwischen ` +
        `${minField2} und ${maxField2} ein.`;

      error2.style.display = 'block';
      isValid = false;
    } else {
      error2.style.display = 'none';
    }

    return isValid;
  }

  let selectingForCustomSize = false;

  function selectVariantOption(option) {
    if (option.type === 'radio') {
      if (option.element.checked) return;

      /*
       * click() löst die vorhandene Vessel-Logik zuverlässig aus.
       */
      option.element.click();
      return;
    }

    if (option.type === 'select' && sizeSelect) {
      if (sizeSelect.value === option.element.value) return;

      sizeSelect.value = option.element.value;

      sizeSelect.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );

      sizeSelect.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }
  }

  function findAndSelectMatchingVariant() {
    if (!validateInputs()) return;

    const inputV1 = parseInt(field1.value, 10);
    const inputV2 = parseInt(field2.value, 10);

    const availableV1 = [
      ...new Set(sizeOptions.map((option) => option.val1))
    ].sort((a, b) => a - b);

    const availableV2 = [
      ...new Set(sizeOptions.map((option) => option.val2))
    ].sort((a, b) => a - b);

    const targetV1 =
      availableV1.find((value) => value >= inputV1) ||
      Math.max(...availableV1);

    const targetV2 =
      availableV2.find((value) => value >= inputV2) ||
      Math.max(...availableV2);

    const match = sizeOptions.find((option) => {
      return (
        option.val1 === targetV1 &&
        option.val2 === targetV2
      );
    });

    if (!match) {
      console.warn(
        `Custom Size: Keine Größenkategorie für ` +
        `${inputV1} × ${inputV2} mm gefunden.`
      );

      return;
    }

    selectingForCustomSize = true;
    try {
      selectVariantOption(match);
    } finally {
      selectingForCustomSize = false;
    }
  }

  function handleCustomSizeInput() {
    updateProperties();
    validateInputs();

    clearTimeout(timer);

    timer = setTimeout(
      findAndSelectMatchingVariant,
      800
    );
  }

  field1.addEventListener('input', handleCustomSizeInput);
  field2.addEventListener('input', handleCustomSizeInput);

  /*
   * Manuelle Auswahl über Schaltflächen.
   */
  sizeOptions
    .filter((option) => option.type === 'radio')
    .forEach((option) => {
      option.element.addEventListener('change', function () {
        if (!this.checked || selectingForCustomSize) return;

        field1.value = option.val1;
        field2.value = option.val2;

        updateProperties();
      });
    });

  /*
   * Manuelle Auswahl über Dropdown.
   */
  if (sizeSelect) {
    sizeSelect.addEventListener('change', function () {
      if (selectingForCustomSize) return;
      const selected = sizeOptions.find((option) => {
        return (
          option.type === 'select' &&
          option.element.value === sizeSelect.value
        );
      });

      if (!selected) return;

      field1.value = selected.val1;
      field2.value = selected.val2;

      updateProperties();
    });
  }

  ensurePropertiesExist();
  updateProperties();

  /*
   * Add-to-Cart validieren.
   */
  const addToCartComponent = document.querySelector(
    'add-to-cart-component'
  );

  const addToCartButton = addToCartComponent?.querySelector(
    '[ref="addToCartButton"]'
  );

  if (addToCartButton) {
    addToCartButton.addEventListener(
      'click',
      function (event) {
        let isValid = true;

        if (!validateInputs()) {
          console.log(
            'Custom Size: Größenvalidierung fehlgeschlagen.'
          );

          isValid = false;
        }

        if (
          window.validateCheckbox &&
          !window.validateCheckbox()
        ) {
          console.log(
            'Custom Size: Pflichtbestätigung fehlt.'
          );

          isValid = false;
        }

        if (!isValid) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          return false;
        }
      },
      true
    );
  }

  console.log(
    `Custom Size initialisiert: ${
      sizeSelect ? 'Dropdown' : 'Schaltflächen'
    }`
  );
})();